import { pageTypes } from '@/constants/types';

// clipboard copy
export const copyToClipboard = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard
      .writeText(text)
      .then(() => console.log('Text copied to clipboard'))
      .catch((err) => console.error('Failed to copy text: ', err));
  } else {
    console.log('Failed to copy text!');
  }
};

// price format
// export const formatPrice = (priceValue) => {
//   const price = parseFloat(priceValue);

//   const [integerPart, decimalPart = '00'] = price
//     .toFixed(2)
//     .toString()
//     .split('.');

//   if (integerPart.length <= 3) {
//     return `${integerPart}.${decimalPart}`;
//   }

//   const lastThreeDigits = integerPart.slice(-3);
//   let remainingDigits = integerPart.slice(0, -3);

//   remainingDigits = remainingDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

//   return `${remainingDigits},${lastThreeDigits}.${decimalPart}`;
// };

// savings calculate
export const calculateSavingsPercentage = (
  regularPrice = 0,
  discountedPrice = 0,
) => {
  const regPrice = parseFloat(regularPrice);
  const discPrice = parseFloat(discountedPrice);

  if (regPrice <= 0 || discPrice < 0 || discPrice > regPrice) {
    return null;
  }

  const savings = regPrice - discPrice;
  const savingsPercentage = (savings / regPrice) * 100;
  const decimal = savingsPercentage % 1;

  // If decimal is exactly 0.5 or greater, round up, otherwise round down
  return decimal >= 0.5
    ? Math.ceil(savingsPercentage)
    : Math.floor(savingsPercentage);
};

// cart total items calculate
export const calculateCartTotalQuantity = (cart) =>
  cart.reduce((total, item) => total + item.stockQtty, 0);

// process email address
export const processEmailAddress = (email) => {
  const localPart = email.split('@')[0];

  const sanitizedLocalPart = localPart.replace(/\s+/g, '');

  const cpaitalizedLocalPart =
    sanitizedLocalPart.charAt(0).toUpperCase() + sanitizedLocalPart.slice(1);

  return cpaitalizedLocalPart;
};

// format string to lowercase and remove whitespace
export const formatString = (str) =>
  str.trim().toLowerCase().replace(/\s+/g, '');

// slugify text
export const slugifyText = (text) => text.toString().toLowerCase();
// .trim()
// .replace(/\s+/g, '-')
// .replace(/[^\w\-]+/g, '')
// .replace(/\-\-+/g, '-');

// deslugify text
export const deslugifyText = (slug) => {
  if (slug === undefined || slug === null) {
    return '';
  }

  return slug.toString();
  // .replace(/-/g, ' ')
  // .replace(/\s\s+/g, ' ')
  // .replace(/(^|\s)\S/g, (letter) => letter.toUpperCase());
};

// format name
export const formatName = (name) => {
  if (name?.length <= 2) {
    return name.toUpperCase();
  }

  const firstLetter = name[0];
  const lastLetter = name[name.length - 1];
  const middleAsterisks = '*'.repeat(4);
  const fullName = `${firstLetter}${middleAsterisks}${lastLetter}`;
  return fullName.toUpperCase();
};

// handle screen resize (<1024px)
export const handleScreenResize = (callback) => {
  if (typeof window !== 'undefined') {
    const handleResize = () => {
      callback(window.innerWidth < 1024);
    };
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }
  return undefined;
};

// price format without floating number
export const formatNumber = (price) => {
  const integerPrice = parseFloat(price);

  const integerPart = integerPrice.toString();

  if (integerPart.length <= 3) {
    return integerPart;
  }

  const lastThreeDigits = integerPart.slice(-3);
  let remainingDigits = integerPart.slice(0, -3);

  remainingDigits = remainingDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

  return `${remainingDigits},${lastThreeDigits}`;
};

// Get specific section
export const getPageSection = (sections, key) => {
  const data = sections?.find((section) => section.key === key);

  return data;
};

// Get specific campaign page
export const getSpecificCampaignPage = (pages, slug) => {
  const data = pages?.find((page) => page?.campaign?.slug === slug);

  return data;
};

// Format string with hyphen (ex: "eid-offer")
export const formatStringWithHyphen = (str) =>
  str.trim().toLowerCase().replace(/\s+/g, '-');

// Format string (ex: "Eid Offer")
export const hyphenToTitleCase = (str) => {
  if (!str) return '';

  return str
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const sleep = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

// get section specific data
export const extractSectionData = (data, targetId, targetContentType) => {
  const campaignPage = data.find((item) => item.key === 'campaign_page');
  if (!campaignPage) return null;

  const { sections } = campaignPage;
  if (!sections || sections.length === 0) return null;

  const matchedSection = sections.find(
    (section) =>
      section.id === targetId && section.content_type === targetContentType,
  );

  if (!matchedSection) return null;

  const { title, redirect_url, has_icon, has_timer, details } = matchedSection;

  return {
    title,
    redirect_url,
    has_icon,
    has_timer,
    details,
  };
};

export const calculateTotalSavingsPercentage = (productDataArray) => {
  if (!productDataArray?.length) return 0;

  let totalRegularPrice = 0;
  let totalDiscountedPrice = 0;

  productDataArray.forEach((productData) => {
    const { price, installation_fee, apply_installation_fee, cart_quantity } =
      productData;
    const quantity = cart_quantity || 1;

    totalRegularPrice +=
      (apply_installation_fee === 1
        ? price.regular_price + installation_fee.installation_fee
        : price.regular_price) * quantity;

    totalDiscountedPrice +=
      (apply_installation_fee === 1
        ? price.final_price + installation_fee.offer_price
        : price.final_price) * quantity;
  });

  const totalSavings = totalRegularPrice - totalDiscountedPrice;
  const savingsPercentage = (totalSavings / totalRegularPrice) * 100;
  const decimal = savingsPercentage % 1;

  return decimal >= 0.5
    ? Math.ceil(savingsPercentage)
    : Math.floor(savingsPercentage);
};

export const isActiveSidebarItem = (item, activeLink) => {
  if (!item || !activeLink) return false;

  // Exact match
  if (item.url === activeLink) return true;

  // Match nested paths (e.g., /faq/details/123)
  if (activeLink.startsWith(`${item.url}/`)) return true;

  // Match query param values (e.g., /my-orders?tab=ongoing)
  if (item.activeValue && activeLink.includes(item.activeValue)) return true;

  return false;
};
